export default "__VITE_ASSET__C8A7wd0Y__"